<template>
    <div>
        <stepper class="form-registration" ref="stepper" :config="config" :model="model" @change="currentStep = $event">
            <template v-slot:after-content>
                <div class="d-flex justify-center mb-12">
                    <v-btn rounded large v-if="currentStep > 1" class="mr-3" @click="back()">
                        <v-icon>fa-solid fa-chevron-left</v-icon>
                        <span class="ml-3">Indietro</span>
                    </v-btn>
                    <v-btn rounded large v-if="currentStep < 3" class="ml-3" color="primary" @click="next()">
                        <span class="mr-3">Continua</span>
                        <v-icon>fa-solid fa-chevron-right</v-icon>
                    </v-btn>
                    <v-btn rounded :disabled="progress" large v-if="currentStep === 3" class="ml-3" color="primary" @click="register()">
                        <span class="mr-3">Registrati</span>
                        <v-icon>fa-solid fa fa-user-plus</v-icon>
                    </v-btn>
                </div>
            </template>
        </stepper>
    </div>
</template>

<script>

import Stepper from "@/components/Stepper";
import UserService from "@/service/UserService";
import TaxonomyService from "@/service/TaxonomyService";
import ValidationUtil from "@/utils/ValidationUtil";

const userService = new UserService();
const taxonomyService = new TaxonomyService();
const validationUtil = new ValidationUtil();

export default {
    name: "Register",
    components: {Stepper},
    props: {},
    data() {
        return {

            progress: false,
            currentStep: 1,
            model: {},
            config: {
                steps: [
                    {id: 1, title: 'Account'},
                    {id: 2, title: 'Dati personali'},
                    {id: 3, title: 'Dati professionali'}
                ],
                multiFieldXRow: true,
                errors: {},
                fields: [
                    {
                        name: 'FormField',
                        key: 'username',
                        cols: 12,
                        label: 'Username',
                        required: true,
                        class: 'username-field',
                        maxlength: 100,
                        step: 1,
                        customEvents: {
                            'blur': a => {
                                this.checkUsername(a.target.value);
                            },
                            'input': () => {
                                this.setError('username', '')
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'email',
                        cols: 12,
                        label: 'Email',
                        required: true,
                        maxlength: 100,
                        step: 1,
                        customEvents: {
                            'blur': a => {
                                this.checkEmail(a.target.value);
                            },
                            'input': () => {
                                this.setError('email', '');
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'password',
                        cols: 12,
                        label: 'Password',
                        type: 'password',
                        class: 'form-registration-password',
                        hint: 'La password deve essere lunga almeno 8 caratteri, contenere almeno 1 numero(i), contenere almeno 1 lettera(e) minuscola(e), contenere almeno 1 lettera(e) maiuscola(e), contenere almeno 1 caratteri speciali, ad esempio *,-, oppure #.',
                        required: true,
                        maxlength: 100,
                        step: 1,
                        customEvents: {
                            'input': () => {
                                this.setError('password', '');
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'password2',
                        cols: 12,
                        label: 'Ripeti Password',
                        type: 'password',
                        required: true,
                        maxlength: 100,
                        step: 1,
                        customEvents: {
                            'blur': () => {
                                this.checkPassword();
                            },
                            'input': () => {
                                this.setError('password2', '');
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'firstname',
                        cols: 12,
                        label: 'Nome',
                        required: true,
                        maxlength: 100,
                        step: 2,
                        customEvents: {
                            'blur': () => {
                                this.checkCF();
                            },
                            'input': () => {
                                this.setError('codicefiscale', '');
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'lastname',
                        cols: 12,
                        label: 'Cognome',
                        required: true,
                        maxlength: 100,
                        step: 2,
                        customEvents: {
                            'blur': () => {
                                this.checkCF();
                            },
                            'input': () => {
                                this.setError('codicefiscale', '');
                            }
                        },
                    },
                    {
                        name: 'FormField',
                        key: 'city',
                        cols: 12,
                        label: 'Città /Località',
                        maxlength: 100,
                        step: 2
                    },
                    {
                        name: 'FormSelect',
                        key: 'country',
                        cols: 12,
                        label: 'Nazione',
                        itemValue: 'code',
                        itemText: 'text',
                        items: [],
                        step: 2
                    },
                    {
                        name: 'FormField',
                        key: 'luogonascita',
                        cols: 12,
                        label: 'Luogo di nascita',
                        required: true,
                        maxlength: 100,
                        step: 2
                    },
                    {
                        name: 'FormFieldDatePicker',
                        key: 'datanascita',
                        cols: 12,
                        label: 'Data di nascita',
                        required: true,
                        step: 2,
                        change: () => {
                            this.checkCF();
                        },
                        input: () => {
                            this.setError('codicefiscale', '');
                        }
                    },
                    {
                        name: 'FormField',
                        key: 'codicefiscale',
                        cols: 12,
                        class: 'fiscal-code-field',
                        label: 'Codice fiscale',
                        required: true,
                        maxlength: 16,
                        step: 2,
                        customEvents: {
                            'blur': () => {
                                this.checkCF();
                            },
                            'input': () => {
                                this.setError('codicefiscale', '');
                            }
                        },
                    },
                    {
                        name: 'FormSelect',
                        key: 'rapportolavoro',
                        cols: 12,
                        label: 'Rapporto di lavoro',
                        required: true,
                        items: [],
                        step: 3
                    },
                    {
                        name: 'FormSelect',
                        key: 'provinciaregione',
                        cols: 12,
                        label: 'Provincia - Regione',
                        required: true,
                        items: [],
                        step: 3
                    },
                    {
                        name: 'FormField',
                        key: 'iscrizioneordine',
                        cols: 12,
                        label: 'Numero di iscrizione all\'Ordine',
                        required: true,
                        maxlength: 50,
                        step: 3
                    },
                    {
                        name: 'FormField',
                        key: 'cellulare',
                        cols: 12,
                        label: 'Telefono cellulare',
                        required: true,
                        type: 'tel',
                        maxlength: 100,
                        step: 3
                    },
                    {
                        name: 'FormSelect',
                        key: 'professione',
                        cols: 12,
                        label: 'Professione ECM',
                        required: true,
                        items: [],
                        step: 3
                    },
                    {
                        name: 'FormLink',
                        key: 'link',
                        class: 'mt-5 d-flex justify-center',
                        href: 'https://fad.medplay.it/_assets/privacy.pdf',
                        cols: 6,
                        label: 'Leggi le condizioni di utilizzo del sito\n',
                        step: 3
                    },
                    {
                        name: 'FormCheckBox',
                        key: 'privacy',
                        colClass: 'd-flex justify-center',
                        cols: 6,
                        label: 'Ho letto le condizioni e le accetto',
                        required: true,
                        items: [],
                        step: 3
                    }
                ]
            }
        }
    },

    methods: {
        next() {
            this.$refs.stepper.currentStep++;
            this.currentStep++;
        },

        back() {
            this.$refs.stepper.currentStep--;
            this.currentStep--;
        },

        register() {

            if (!this.$refs.stepper.validate()) {
                this.$root.$snackbar.show('Ci sono dati non inseriti o non corretti, ti chiediamo di scorrere il modulo di registrazione e aggiornare tutti i campi indicati come non corretti', 'red');
                return;
            }

            this.progress = true;

            userService.register(this.model).then((result) => {

                if (result) {
                    this.$router.push('/signup-success');
                }
            }, error => {
                if (error.response.data.field) {
                    this.setError(error.response.data.field, error.response.data.message);
                }
                this.$root.$snackbar.show(error.response.data.message, 'red');
            }).finally(() => {
                this.progress = false;
            });
        },

        checkUsername(username) {
            if (username) {
                userService.checkUsername(username.toLowerCase()).then(() => {}, error => {
                    this.setError('username', error.response.data.message)
                });
            }
        },

        checkEmail(email) {
            if (email) {

                if (!validationUtil.validateEmail(email)) {
                    this.setError('email', 'Email non valida');
                    return;
                }

                userService.checkEmail(email).then(() => {}, error => {
                    this.setError('email', error.response.data.message)
                });
            }
        },

        checkCF() {
            if (this.model.codicefiscale) {
                userService.checkCF(this.model.codicefiscale, this.model.firstname, this.model.lastname, this.model.datanascita).then(() => {}, error => {
                    this.setError('codicefiscale', error.response.data.message);
                });
            }
        },

        checkPassword() {
            if (this.model.password !== this.model.password2) {
                this.setError('password2', 'Le password non coincidono');
            }
        },

        setError(field, message) {
            this.$set(this.config.errors, field, message);
        }
    },

    mounted() {

        if (localStorage.getItem('register-test-user')) {
            this.model = JSON.parse(localStorage.getItem('register-test-user'));
        }

        taxonomyService.get().then(res => {
            this.config.fields.find(i => i.key === 'rapportolavoro').items = res.data.rapportolavoro;
            this.config.fields.find(i => i.key === 'provinciaregione').items = res.data.provinciaregione;
            this.config.fields.find(i => i.key === 'professione').items = res.data.professione;
            this.config.fields.find(i => i.key === 'country').items = res.data.country;
        });
    }
}
</script>
